import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

import { infrastructureQueryLinkerSchema } from './infrastructure-query-linker-schema';

export const infrastructureQuerySchema = z.object({
  ...infrastructureQueryLinkerSchema.shape,
  location: z.string(),
  ip: z.string(),
  country_id: z.number().nullable(),
  state_short_name: z.string().nullable(),
  notes: z.string().nullable(),
});

export type InfrastructureQuerySchema = z.infer<typeof infrastructureQuerySchema>;

export const infrastructureQueryAllSchema = paginatedResponseSchema(infrastructureQuerySchema);

export type InfrastructureQueryAllSchema = z.infer<typeof infrastructureQueryAllSchema>;
